export const getAuth = state => state.firebase.auth
